import { DefaultLocale, isValidLanguage, } from '@data/types/common';
import { languages } from '@data/static/languages';
/**
 * Reads the language segment a Booking Engine URL may start with — `/pt/...`,
 * `/pt-br/...` — or undefined when the path carries none.
 *
 * Lives here rather than with the other URL parsers so `@data/other/i18n` can
 * use it without the data layer importing from `@view/*`;
 * `@view/utils/urlParsers` re-exports it.
 */
export function parseUrlLanguage(pathname) {
    const parts = pathname.split('/').filter(Boolean);
    let lang = parts[0];
    if (lang === 'pt')
        lang = 'pt-br';
    return isValidLanguage(lang || '') ? lang : undefined;
}
export function languageToLocale(language) {
    var _a;
    return (((_a = languages.find((x) => x.code === language)) === null || _a === void 0 ? void 0 : _a.locale) ||
        DefaultLocale);
}
